import React from "react";
import { useEditor } from "@tiptap/react";
import TiptapText from "@tiptap/extension-text";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import Document from "@tiptap/extension-document";
import ListItem from "@tiptap/extension-list-item";
import Paragraph from "@tiptap/extension-paragraph";
import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import { Mention } from "@tiptap/extension-mention";

import Text, { TextFontWeight, TextType } from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

const extensions = [
  Document,
  Paragraph,
  TiptapText,
  Bold,
  Italic,
  ListItem,
  BulletList,
  OrderedList,
  HorizontalRule,
  Mention.configure({ HTMLAttributes: { class: "mention" } }),
];

export const useInlinePlainText = (content: string) => {
  const [text, setText] = React.useState("");
  const editor = useEditor({ extensions, content, editable: false });
  React.useEffect(() => {
    if (editor) {
      editor.commands.setContent(content);
      setText(
        editor.getText({ blockSeparator: " " }).replace(/\s+/g, " ").trim(),
      );
    }
  }, [editor, content]);
  return text;
};

interface Props {
  content: string;
  variant?: TextType;
  fontWeight?: TextFontWeight;
  className?: string;
}

const UnstyledRichTextPreview: React.FC<Props> = (props) => {
  const [textContent, setTextContent] = React.useState("");
  const editor = useEditor({
    extensions,
    content: props.content,
    editable: false,
  });
  React.useEffect(() => {
    if (editor) {
      const text = editor.getText();
      setTextContent(text);
    }
  }, [editor, props.content]);

  return (
    <Text
      type={props.variant || "P2"}
      fontWeight={props.fontWeight || "Regular"}
      className={cn("text-gray-10", props.className)}
      multiline
    >
      {textContent}
    </Text>
  );
};

export default UnstyledRichTextPreview;
